import React from 'react';
import { AnyObject } from 'final-form';
import { Field } from 'react-final-form';

import { createFormField } from 'Shared/utils/createFormField';

import FormSelect from './FormSelect/FormSelect';

import './WorkspaceForm.scss';

function WorkspaceForm({ value: workspace, name, groupRecurringMeetings, teammateRecurringMeetings }: AnyObject) {
  return (
    <div className="mb-4 WorkspaceForm">
      <div className="d-flex">
        <b>Workspace:</b>
        <div className="WorkspaceForm__name ml-2">{workspace.title}</div>
      </div>
      <Field
        name={`${name}.recurringMeeting`}
        component={FormSelect}
        isGroup={workspace.isGroup}
        groupRecurringMeetings={groupRecurringMeetings}
        teammateRecurringMeetings={teammateRecurringMeetings}
      />
    </div>
  );
}

export default createFormField(WorkspaceForm);
